import { Tabs } from 'antd';
import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { useParams } from 'react-router-dom';

const TAB_ITEMS = [
  { label: 'Overview', path: '', key: '1' },
  { label: 'Activity', path: '/activity', key: '2' },
];

function Container() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: companyId } = useParams();

  const activeKey = React.useMemo(() => {
    const path = location.pathname;
    if (path.includes('/activity')) return '2';
    return '1';
  }, [location.pathname]);

  return (
    <div style={{ padding: 24 }}>
      <Tabs
        items={TAB_ITEMS}
        activeKey={activeKey}
        onChange={(key) => {
          const tab = TAB_ITEMS.find((t) => t.key === key);
          if (tab) navigate(`/console/customers/companies/${companyId}${tab.path}`);
        }}
      />
      <Outlet />
    </div>
  );
}

export default Container;
